import * as React from 'react';

export const ilFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3184)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_55_3184'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#F0F0F0'
                />
            </mask>
            <g mask='url(#mask0_55_3184)'>
                <path
                    d='M17 8.00004H14.6667L13.5 6L12.3333 7.99998H10L11.1668 10L10 11.9999H12.3333L13.5 14L14.6667 12H17L15.8332 9.99997L17 8.00004ZM14.9333 9.99997L14.2167 11.2286H12.7834L12.0667 9.99997L12.7834 8.77134H14.2167L14.9333 9.99997ZM13.5 7.54278L13.7667 8.00004H13.2333L13.5 7.54278ZM11.35 8.77134H11.8835L11.6167 9.22861L11.35 8.77134ZM11.35 11.2287L11.6166 10.7714L11.8834 11.2287H11.35ZM13.5 12.4572L13.2333 11.9999H13.7667L13.5 12.4572ZM15.65 11.2287H15.1165L15.3833 10.7714L15.65 11.2287ZM15.1165 8.77134H15.65L15.3834 9.22861L15.1165 8.77134Z'
                    fill='#2E52B2'
                />
                <path
                    d='M28 16H0V18H28V16Z'
                    fill='#2E52B2'
                />
                <path
                    d='M28 2H0V4H28V2Z'
                    fill='#2E52B2'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3184'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
